import type { HelpFile } from '../../types/help'
import { RestrictionRuleDetectionsTestIds } from '../../../testids/RestrictionRuleDetectionsTestIds'

export const restrictionRuleDetectionsHelp: HelpFile = {
  docPage: '/docs/governance/restriction-rules',
  texts: {
    [RestrictionRuleDetectionsTestIds.restrictionRuleDetections]:
      'Violation detection runs across all restriction rules — use the rule filter to narrow to a specific rule.',
    [RestrictionRuleDetectionsTestIds.btnClearRuleFilter]:
      'Show detections from all restriction rules.',
    [RestrictionRuleDetectionsTestIds.colRule]:
      'Restriction rule that triggered this detection run.',
    [RestrictionRuleDetectionsTestIds.colDetectionStartedAt]:
      'When the detection run began.',
    [RestrictionRuleDetectionsTestIds.colStatus]:
      'Outcome of the detection run — running, completed, or failed.',
    [RestrictionRuleDetectionsTestIds.colIdentitiesEvaluated]:
      'Identities scanned by this detection run.',
    [RestrictionRuleDetectionsTestIds.colViolationsFound]:
      'New violations identified during this run.',
    [RestrictionRuleDetectionsTestIds.colViolationsResolved]:
      'Previously open violations cleared by this run.',
  },
}
